import { changeLanguage } from "@/i18n/changeLanguage";
import { getDefaultLanguage } from "@/i18n/getDefaultLanguage";

/**
 * Observes changes to the HTML lang attribute and updates the widget language accordingly
 * @returns void
 */
export default function observeHTMLLang(): void {
  try {
    const htmlElement = document.documentElement;

    if (!htmlElement) {
      console.warn('HTML element not found, cannot observe lang attribute');
      return;
    }

    const observer = new MutationObserver((mutations) => {
      try {
        for (const mutation of mutations) {
          if (mutation.type === "attributes" && mutation.attributeName === "lang") {
            const newLanguage = getDefaultLanguage();
            changeLanguage(newLanguage, true);
          }
        }
      } catch (error) {
        console.error('Error handling lang attribute mutation:', error);
      }
    });

    observer.observe(htmlElement, { 
      attributes: true,
      attributeFilter: ['lang']
    });

    // Store observer reference for potential cleanup
    (window as any).__cya11y__langObserver = observer;
  } catch (error) {
    console.error('Failed to observe HTML lang attribute:', error);
  }
}